/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Expense_Rule_EmptyInputs */

const vi_expense_rule_empty = /** @type {(inputs: Expense_Rule_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có quy tắc nào. Thêm quy tắc đầu tiên để bắt đầu tự phân loại.`)
};

/**

* @param {Expense_Rule_EmptyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const expense_rule_empty = /** @type {((inputs?: Expense_Rule_EmptyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Expense_Rule_EmptyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_expense_rule_empty(inputs)
});